/** Owns the shared saved-search save/navigation contract for both broadcast list screens; Vue Router handles URL encoding. */

/**
 * Creates the existing persisted filter shape from the current search controls.
 * @param {Object} options Current query text, payload filters and optional isDigest=false.
 * @returns {Object} Saved-search API payload; booleans normalized without truthiness coercion.
 */
export function createSavedSearchPayload({ query, payload, isDigest = false }) {
  // Save only durable alert conditions supported by the existing SQL/API contract.
  return {
    q: query || undefined,
    listType: payload.listType ? Number(payload.listType) : undefined,
    broadcastType: payload.type || undefined,
    companyId: payload.companyId ? Number(payload.companyId) : undefined,
    exactPhrase: payload.exactPhrase === true || payload.exactPhrase === "true" || payload.exactPhrase === 1,
    country: payload.country || undefined,
    isDigest,
  }
}

/**
 * Restores every persisted condition and marks the results as lexical/newest-first.
 * @param {Object} savedSearch Persisted q/listType/broadcastType/companyId/exactPhrase/country.
 * @returns {Object} Vue Router location; no manually concatenated or pre-encoded query text.
 */
export function buildSavedSearchRoute(savedSearch) {
  // String route values survive Vue Router serialization without losing company or exact-phrase filters.
  const query = { savedSearch: "true" }
  if (savedSearch.q) query.query = savedSearch.q
  if (savedSearch.listType) query.listType = String(savedSearch.listType)
  if (savedSearch.broadcastType) query.type = savedSearch.broadcastType
  if (savedSearch.companyId) query.companyId = String(savedSearch.companyId)
  if (savedSearch.exactPhrase === true || savedSearch.exactPhrase === "true" || savedSearch.exactPhrase === 1) query.exactPhrase = "true"
  if (savedSearch.country) query.country = savedSearch.country

  // Routing by object delegates reserved characters/spaces to Vue Router rather than altering the saved text.
  return { path: "/broadcasts", query }
}
